const getNewFooterNavigationAlpineData = () => ({
    currentIndicatorStyle: {
        'left': '50%',
        'width': 0
    },
    /**
     * AlpineJS DOM element attributes (applied using the "x-bind" directive):
     */
    footerNavigationAttributes: {
        ['x-id']() {
            return ['footerNavigation'];
        },
        ['@focusin']($event) {
            this.handleMouseOrFocusIn($event);
        },
        ['@mouseover']($event) {
            this.handleMouseOrFocusIn($event);
        },
        ['@focusout']($event) {
            this.handleMouseOrFocusOut($event);
        },
        ['@mouseout']($event) {
            this.handleMouseOrFocusOut($event);
        }
    },
    /**
     *  Functions:
     */
    init() {
        this.$nextTick(() => {
            const activeLink = this.$refs.footerNavigationActiveLink;
            if (activeLink) {
                this.setIndicatorWithTarget(activeLink);
            }
        });
    },
    isValidFooterNavigationTarget(target: HTMLElement) {
        return this.$refs.footerNavigation.contains(target) && target.classList.contains('footernav__link');
    },
    handleMouseOrFocusIn($event) {
        const target = $event.target;
        if (this.isValidFooterNavigationTarget(target)) {
            this.setIndicatorWithTarget(target);
        }
    },
    handleMouseOrFocusOut($event) {
        const target = $event.target;
        if (this.isValidFooterNavigationTarget(target)) {
            this.resetIndicatorToActiveLink();
        }
    },
    resetSlidingIndicator() {
        this.currentSlidingIndicatorStyle['left'] = null;
        this.currentSlidingIndicatorStyle['width'] = 0;
    },
    setIndicatorWithTarget(target: HTMLElement = null) {
        if (!target) {
            return;
        }
        const leftAndWidth = this.calculateLeftAndWidthFromLinkTarget(target);
        this.currentIndicatorStyle['left'] = leftAndWidth.left;
        this.currentIndicatorStyle['width'] = leftAndWidth.width;
    },
    resetIndicatorToActiveLink() {
        const activeLink = this.$refs.footerNavigationActiveLink;
        if (activeLink) {
            this.setIndicatorWithTarget(activeLink);
        } else {
            this.currentIndicatorStyle['left'] = '50%';
            this.currentIndicatorStyle['width'] = 0;
        }
    },
    calculateLeftAndWidthFromLinkTarget(target: HTMLElement) {
        const targetLabel = target.querySelector('.footernav__link__label');
        return {
            'left': `${target.offsetLeft + parseInt(window.getComputedStyle(target).paddingLeft)}px`,
            'width': `${targetLabel.clientWidth}px`
        };
    }
});


const FooterNavigation = {
    init: (element: HTMLElement) => {
        FooterNavigation.initAlpineData();
    },
    initAlpineData: () => {
        document.addEventListener('alpine:init', () => {
            Alpine.data('footerNavigation', () => (getNewFooterNavigationAlpineData()));
        });
    }
};

export default FooterNavigation;
